import e from"../../server/react-server/getConfig.js";async function r(){return(await e()).locale}export{r as default};
